import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "../../assets/css/infoCard.css";
export default function InfoCard({ 
    onClick, 
    icon,
     title, 
    specialSubTitle, 
    subTitle, 
    subTitle2, 
    firstValue, 
    secondValue, 
    thirdValue, 
    link, 
    className = "", 
    CustomizedSubtitles,
    display = "display-6" }) {
    return (
        <div onClick={onClick} className={`shadow h-100 p-3 infoCard ${link ? "link" : ""} d-flex flex-column justify-content-between ${className}`}>
            <div className='d-flex align-items-start justify-content-between mb-3 '>
                <div className='d-flex align-items-center '>
                    {icon && <FontAwesomeIcon icon={icon} />}
                    {title && <h5 className='m-0 ms-2 fw-normal title'>{title}</h5>}
                </div>
                {firstValue && <p className='fw-bold m-0'>{firstValue}</p>}
            </div>
            {
                specialSubTitle
                    ?
                    <div className='d-flex align-items-center justify-content-center'>
                        <span className={`fw-bold ${display} special`}>{specialSubTitle}</span>
                    </div>
                    :
                    <></>
            }
            {(subTitle || secondValue) &&
                <div className='d-flex align-items-center justify-content-between mt-3'>
                    {subTitle && <p className='m-0'>{subTitle}</p>}
                    {secondValue && <p className='fw-bold m-0'>{secondValue}</p>}
                </div>
            }
            {
                (subTitle2 || thirdValue) &&
                <div className='d-flex align-items-center justify-content-between mt-3'>
                    {subTitle2 && <p className='m-0'>{subTitle2}</p>}
                    {thirdValue && <p className='fw-bold m-0'>{thirdValue}</p>}
                </div>
            }
            {CustomizedSubtitles && <CustomizedSubtitles />}

        </div>
    )
}